import $ from 'jquery';
import throttle from '../utils/throttle';
import debounce from '../utils/debounce';

const itemSelector = '.js-nav-item-parent';
const navOpenClass = 'is-nav-open';

const $body = $('body');
const $siteHeader = $('.js-site-header');
const $navToggle = $('.js-nav-toggle');
const $navMenuContainer = $('.js-nav-menu-container');
const $menuLevelToggleButtons = $('.js-sub-nav-toggle-button');
const $announcementBar = $('.js-announcement-bar');

let siteHeaderHeight = $siteHeader.outerHeight();

$navToggle.on('click', function(e) {

	if ($body.hasClass(navOpenClass)) {
		$body.removeClass(navOpenClass);
		return false;	
	}

	let windowHeight = window.innerHeight;
	let announcementBarHeight = 0;

	if ($announcementBar.length) {
		announcementBarHeight = $announcementBar.outerHeight();
	}
	
	let navMaxHeight = windowHeight - announcementBarHeight;

	$('body').addClass(navOpenClass);

	$navMenuContainer.outerHeight(navMaxHeight);

});

$menuLevelToggleButtons.on('click', function(e) {

	e.preventDefault();

	const $clickedItem = $(e.target).closest(itemSelector);

	if ($clickedItem.hasClass('is-open')) {
		$clickedItem
			.removeClass('is-open')
			.children('.js-sub-menu')
			.first()
				.slideUp();
		return false;
	}

	// find siblings with children
	$clickedItem.siblings().filter(itemSelector).each((i, el) => {
		$(el)
			.removeClass('is-open')
			.children('.js-sub-menu')
				.slideUp();
	});
	
	$clickedItem
		.addClass('is-open')
		.children('.js-sub-menu')
		.first()
			.slideDown();

});

$(window).on('scroll', throttle(() => {
	if (window.scrollY > siteHeaderHeight) {
		$siteHeader.addClass('is-sticky');
	} else {
		$siteHeader.removeClass('is-sticky');
	}
}, 250));

$(window).on('resize', debounce(() => {
	siteHeaderHeight = $siteHeader.outerHeight();
}));
